import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom' 
import posts from './PostData' 

function BlogList() {
  return (
    <div className="px-6 sm:px-24">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-[24px] text-center sm:text-[44px] text-text-color1 mb-10"
      >
        Our Blog
      </motion.h1>

      <div className="grid sm:grid-cols-4 gap-8">
        {posts.map((post) => (
          <motion.div
            key={post.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-white rounded-lg shadow-md overflow-hidden"
          >
            <img src={post.image} alt={post.title} className="w-full h-50 object-contain" />
            {/* <img src={post.image} alt={post.title} className="w-full h-56 object-cover" /> */}
            <div className="p-6">
              <p className="text-sm text-gray-500">{post.date}</p>
              <h2 className="text-xl font-semibold text-text-color1 mb-2">{post.title}</h2>
              <p className="text-gray-700 mb-4">{post.preview}</p>
              <Link
                to={`/blog/${post.id}`}
                className="text-primary-color font-medium hover:underline"
              >
                Read More →
              </Link>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default BlogList
